import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import 'handsontable/dist/handsontable.full.min.css';
import { usePTS } from "../../context/PTSContext";
import ReportSidebar from './ReportSidebar.jsx';
import "../../App.css";
import ReportSectionRenderer from './ReportSectionRenderer.jsx';
import config from '../../devprodConfig.js';
import { Riskidataa } from '../../assets/Riskidata';
import {
  getKiinteistoWhole,
  getReportsByKiinteisto,
  createReportFromTemplateType,
  getTemplateByType,
} from '../../api/api.js';


const ReportTemplate = () => {

  const {
    id: kiinteistoId,
    templateName,
    reportId,
    section,
    sectionId,
  } = useParams();


  const { availablePTSSections, setAvailablePTSSections } = usePTS();
  
  const [mergedRakennusData, setMergedRakennusData] = useState(null);

  const [rakennusData, setRakennusData] = useState(null);
  
  const [report, setReport] = useState(null);
  const [sections, setSections] = useState([]);

  const [editMode, setEditMode] = useState(false);

  const riskidata = Riskidataa


  // ======= Fetch Kiinteistö + Report =======
  useEffect(() => {
       fetchData();
  }, [kiinteistoId, templateName]);

  const fetchData = async () => {
    try {
      let fetchedReport = null;

      if (kiinteistoId) {
        // 🔹 1. Fetch property
        const kiinteistoResp = await getKiinteistoWhole(kiinteistoId);
        const kiinteistoData = kiinteistoResp.data;
        setRakennusData(kiinteistoData);

        // 🔹 2. Fetch reports for property
        const reportsResp = await getReportsByKiinteisto(kiinteistoId);
        const reportsData = reportsResp.data || [];

        // 🔹 3. Try to find one matching this report type
        fetchedReport = reportsData.find(r => r.type === templateName);

        // 🔹 4. If not found, create it
        if (!fetchedReport) {
          console.log(`No existing report for type ${templateName}, creating new one...`);
          const createdReportResp = await createReportFromTemplateType(
            kiinteistoId,
            templateName
          );
          fetchedReport = createdReportResp.data;
        }

        // 🔹 5. Fetch PTS data using real kiinteistötunnus
        if (kiinteistoData?.kiinteistotunnus) {
          try {
            const tunnus = kiinteistoData.kiinteistotunnus;
            console.log("🔍 Fetching PTS list for kiinteistötunnus:", tunnus);

            const res = await fetch(`${config.apiBaseUrl}/api/pts/by/kiinteistotunnus/${tunnus}`, {
              credentials: "include",
            });
            const list = await res.json();
            console.log("📄 PTS list response:", list);

            if (list?.length) {
              const latestPTSId = list[0].id;
              console.log("✅ Using latest PTS ID:", latestPTSId);

              const resFull = await fetch(`${config.apiBaseUrl}/api/pts/${latestPTSId}`, {
                credentials: "include",
              });
              const ptsData = await resFull.json();
              console.log("📦 Full PTS data:", ptsData);

              const entries = ptsData.entries || [];
              if (entries.length) {
                const grouped = {};
                entries.forEach((e) => {
                  const cat = e.category || "Muu";
                  const sec = e.section || "Muu";
                  if (!grouped[cat]) grouped[cat] = new Set();
                  grouped[cat].add(sec);
                });

                const formatted = {};
                for (const [cat, set] of Object.entries(grouped)) {
                  formatted[cat] = Array.from(set);
                }

                console.log("📤 Setting availablePTSSections:", formatted);
                setAvailablePTSSections(formatted);
              }
            } else {
              console.warn("⚠️ No PTS records found for this kiinteistö.");
            }
          } catch (err) {
            console.error("❌ Failed to load PTS sections:", err);
          }
        }
      } else {
        // 🔹 6. No property ID → just load the standalone template
        console.log(`No kiinteistö ID provided, fetching template by type: ${templateName}`);
        const templateResp = await getTemplateByType(templateName);
        fetchedReport = templateResp.data;
      }

      // 🔹 7. Set up report data in state
      if (fetchedReport) {
        setReport(fetchedReport);
        setSections(fetchedReport.report_sections || []);
      }

      // ✅ Return the fresh report for immediate use
      return fetchedReport;
    } catch (err) {
      console.error('Error fetching report or template:', err);
      return null;
    }
  };


  // ======= Render =======
  return (
    <div className="d-flex flex-column flex-md-row" style={{ minHeight: '100vh' }}>
      {/* Sidebar */}
      {report && (
        <div
          className="bg-white border-bottom border-md-end"
          style={{
            width: '100%',
            maxWidth: 280,
            flexShrink: 0,
          }}
        >
          <ReportSidebar
            report={report}
            templateName={templateName}
            fetchData={fetchData}
            rakennusData={mergedRakennusData || rakennusData} 
            riskidata={riskidata}
            editMode={editMode}
            setEditMode={setEditMode}
          />
        </div>
      )}
      {/* <ZoomWrapper zoom={0.7}> */}
      {/* Main content */}
      <div
        className="flex-grow-1"
        style={{
          backgroundColor: '#f8f9fa',
          padding: '1rem',
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
        }}
      >

    <div className="report-width-container">
        <ReportSectionRenderer
          report={report}
          sections={sections}
          setSections={setSections}
          activeSectionKey={section}
          availablePTSSections={availablePTSSections}
          kiinteisto={rakennusData}
          
          editMode={editMode}
          onMergedKiinteistoChange={setMergedRakennusData}
        />
    </div>

    </div>
      {/* </ZoomWrapper> */}


    </div>
  );
};

export default ReportTemplate;
